import { IEmployeeFormServiceMock } from './employee-form.mock.types';

export const mockEmployeeFormService = (): IEmployeeFormServiceMock => ({
  //submissions
  fetchEmployeeFormSubmissions: jest.fn(),
  fetchEmployeeFormSubmission: jest.fn(),
  updateEmployeeFormSubmissionState: jest.fn(),
  createEmployeeFormSubmission: jest.fn(),
  updateEmployeeFormSubmission: jest.fn(),
  deleteEmployeeFormSubmission: jest.fn(),
  exportEmployeeFormSubmissionPDF: jest.fn(),

  // activities
  fetchEmployeeFormSubmissionActivities: jest.fn(),

  fetchEmployeeFormSubmissionChecklists: jest.fn(),
  updateEmployeeFormSubmissionChecklist: jest.fn(),
  markCompleteEmployeeFormSubmissionChecklist: jest.fn(),
  fetchChecklistAssigneeOptions: jest.fn(),
  updateEmployeeFormSubmissionChecklistAssignee: jest.fn(),

  fetchEmployeeFormSubmissionDepartments: jest.fn(),

  // comments
  fetchEmployeeFormSubmissionComments: jest.fn(),
  fetchEmployeeFormSubmissionComment: jest.fn(),
  createEmployeeFormSubmissionComment: jest.fn(),
  updateEmployeeFormSubmissionComment: jest.fn(),
  deleteEmployeeFormSubmissionComment: jest.fn(),

  addEmployeeFormSubmissionCommentAttachments: jest.fn(),
  removeEmployeeFormSubmissionCommentAttachment: jest.fn(),

  // mentions
  fetchEmployeeFormSubmissionCommentsMentionableUsers: jest.fn()
});
